<template>
    <div class="infoengine">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-6">
                    <h2 class="filter-heading">Name Screening Score Factors</h2>
                </div>
                <div class="col-md-3 filter-for-override" >
                    <b-form-group
                            id="input-group-4"

                    >
                        <b-form-select name="DataSegment" v-validate="{ required: true }" v-model="dataSegmentIdToFetch" :options="dataSegmentOptions"></b-form-select>
                    </b-form-group>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table :items="data" :fields="fields">
                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('modify-score-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <modify-score-popup></modify-score-popup>
        <base-records
            path="configurations/name-screening-scores"
            :query="query"
            :reset="reset"
            :show-pagination="false"
        ></base-records>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import modifyScorePopup from '@/components/popups/ModifyScorePopup.vue'
import Resource from '@/api/resource'
const apiResource = new Resource('configurations/get-all-dataSegments/')
export default {
    components: {
        modifyScorePopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: [
                {
                    key: 'code',
                    label: 'Code',
                    class: 'w-320px',
                    sortable: true,
                },
                {
                    key: 'factor',
                    label: 'Screening Factor',
                    class: 'w-320px',
                    sortable: true,
                    // formatter: (value) => {
                    //     return _.startCase(value)
                    // },
                },
                {
                    key: 'score',
                    label: 'Score',
                    class: 'text-center',
                    sortable: true,
                },
                {
                    key: 'action',
                    label: 'ACTION',
                    class: 'single-list',
                },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 100,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'code',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
            dataSegmentIdToFetch:'',
            dataSegmentOptions: [],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > methods


    watch: {
        async dataSegmentIdToFetch(value){
            await this.apply()
            await this.getRolesList()
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getRolesList();
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        apply() {
            this.$store.commit('setLoading', true)
            this.query.dataSegmentId = this.dataSegmentIdToFetch
            this.reset = new Date().getTime()
        },
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
        }, // End of sortingChanged() method
        async getRolesList(){
            const result = await apiResource.list();
            if(result && result.data){
                let tempDataSegments= result.data.data.map(el => ({value: el._id, text: el.title}));
                tempDataSegments= [{value: '', text: 'All DataSegments'} , ...tempDataSegments]
                this.dataSegmentOptions = tempDataSegments;

                let fetchSelected = result.data.data.map(el => {
                    if (this.dataSegmentIdToFetch!='' && el._id==this.dataSegmentIdToFetch) {
                        return el;
                    }
                    else if(this.dataSegmentIdToFetch=='' && el._id==this.dataSegmentId)
                    {
                        return el;
                    }
                });
                // fetchSelected = fetchSelected.filter(el => el !== undefined && el !== null);
                // this.currency = fetchSelected[0].currency

            }

        },

    }, // End of Component > mounted
} // End of export default
</script>
